import $ from 'jquery'
import 'slick-carousel'

export default {
	init() {
		// JavaScript to be fired on all pages
	},
	finalize() {
		// JavaScript to be fired on all pages, after page specific JS is fired
			$('.financeandleasing-slides').slick({
				slide: '.sbs_block',
				rows: 0, //removes inline-block
				infinite: false,
				slidesToShow: 1,
				variableWidth: false,
				// adaptiveHeight: true,
				asNavFor: '.financeandleasing-controls ul',
				dots: true,
				arrows: false,
			});
			$('.financeandleasing-controls .fl_control').slick({
				slidesToShow: 4,
				arrows: false,
				asNavFor: '.financeandleasing-slides',
				dots: false,
				focusOnSelect: true,
			});

			// Ugh
			$('.fl_container').on('click', '.fl_dropdown', function() {
				$('.fl_container').toggleClass('closed');
				$('.fl_container').toggleClass('open');
			});
			$('.fl_container').on('click', '.slick-slide', function() {
				$('.fl_container').toggleClass('open');
				$('.fl_container').toggleClass('closed');
			});
	},
};



// WEBPACK FOOTER //
// ./scripts/routes/financeandleasing.js